import React, { useState, useRef } from 'react';
import dynamic from 'next/dynamic';
const Select = dynamic(() => import('react-dropdown-select'), { loading: () => <></> });
import Accordian from '../../../../utils/accordion';
import Studies from './studies';
import Leadership from './leadership';
import Advanced from './advanced';
import Education from './education';
import Chaplaincy from './chaplaincy';
import DoctorOfMinistry from './doctorMinistry';
import RequestInfoModal from '../../../common/requestInfoModal';

function Degree(props) {

	const [showArtDegree, setShowArtDegree] = useState(false);
	const [showDivinityDegree, setShowDivinityDegree] = useState(false);
	const [showDoctorDegree, setShowDoctorDegree] = useState(false);

	const [showLess, setShowLess] = useState(true);
	const [sideBarActiveState, setSideBarActiveState] = useState({ "studies": true, "leadership": false, "advanced": false, "education": false});

	const elementRef = useRef([]);
	const [openRequestInfoModal, setOpenRequestInfoModal] = useState(false);

	const [requiredAccordions, setRequiredAccordions] = useState([
		{
			heading: 'The Quran...',
			content: '<h3>The Quran: Composition, Collection, and Teachings</h3><p>This course aims to introduce students to the collection, compilation and standardization of the Qur’an along with its main features, structure, and themes. We will examine the different interpretive processes and approaches employed by exegetes, from the classical to the modern period, to yield meaning that is relevant to confront theological, legal and social issues. The course will also address the role of the Qur’an in everyday life and thought of a Muslim.</p>',
			open: false
		},
		{
			heading: 'Islamic Theology and Philosophy',
			content: '<h3>Islamic Theology and Philosophy</h3><p>This course is an introduction to the major figures, issues, discussions, and texts of Islamic thought as manifested in the interconnected domains of theology and philosophy. A developmental/ chronological approach will draw connections with other religious and philosophical traditions, and demonstrate confluence and change within Islamic thought over time. Students will also evaluate claims regarding “decline” in Islamic thought in connection to modernity.</p>',
			open: false
		},
		{
			heading: 'Islamic Law and Legal Theory',
			content: '<h3>Islamic Law and Legal Theory</h3><p>This course explains the internal workings of Islamic law at its theoretical roots. It engages students with the tools of ijtihad (the mechanism of Islamic legal reasoning) with an eye to the interpretive methodologies of the various schools of Islamic law. It also explores the relationship between Islamic law and government and surveys two selected areas of substantive law: family and criminal law. It concludes with a look at modern Islamic legal and political reform.</p>',
			open: false
		},
		{
			heading: 'History of Islam',
			content: '<h3>History of Islam</h3><p>This course outlines the expansion of Islam, the rise of the Umayyads; the Abbasid empire and successor states; the emergence of classical Islamic societies and material culture (including architecture, arts, literature); the Crusades and Mongol invasions and Muslim societies’ response; trade and exchange in the Mediterranean and Indian Oceans; the Ottoman/Safavid/Mughal empires; and the anti-colonial intellectual and political responses of new Muslim nation-states. The course provides a foundation for understanding contemporary Muslim societies and transnational Islam.</p>',
			open: false
		},
		{
			heading: 'Islamic Ethics',
			content: '<h3>Islamic Ethics</h3><p>This course surveys the literature in Islamic ethical thought, identifying key themes and topics for Muslims committed to living Islam as a way of life. Students explore how diverse Muslims have chosen to navigate the challenges of global modernity. They also examine how Islamic principles can help Muslims live with integrity in contemporary American society.</p>',
			open: false
		}
	]);

	const [additionalRequiredAccordions, setAdditionalRequiredAccordions] = useState([
		{
			heading: `SUNNI-SHI’A RELATIONS AND INTRA-FAITH ISSUES`,
			content: `<h3>Sunni-Shi’a Relations and Intra-faith Issues</h3><p>This course addresses the emergence of sectarian divisions amongst Muslims in the classical period, and the subsequent development of doctrinal and legal materials sustaining these identities. Historical examples of coexistence and conflict will be analyzed, and more recent efforts to promote intra-faith respect and cooperation will be evaluated.</p>`,
			open: false
		},
		{
			heading: `MUSLIM SPIRITUALITY AMONG THE RELIGIONS OF THE WORLD`,
			content: `<h3>Muslim Spirituality Among the Religions of the World</h3><p>This course situates the diverse religious experiences and spiritual expressions of Islam within a global context. All students gain appreciation for the approaches to enrichment and growth cultivated by Muslims in different socio-political and cultural environments. Muslim students acquire tools for understanding other faiths’ search for meaning and enlightenment.</p>`,
			open: false
		}
	]);


	const toggleActiveState = (btnName) => {
		switch (btnName) {
			case "studies":
				setSideBarActiveState({ "studies": true, "leadership": false, "advanced": false, "education": false });
				break;
			case "leadership":
				setSideBarActiveState({ "studies": false, "leadership": true, "advanced": false, "education": false });
				break;
			case "advanced":
				setSideBarActiveState({ "studies": false, "leadership": false, "advanced": true, "education": false });
				break;
			case "education":
				setSideBarActiveState({ "studies": false, "leadership": false, "advanced": false, "education": true });
				break;
			default:
				break;
		}

	}

	const toggleDegree = (degree) => {
		if (degree === "arts") {
			setShowDivinityDegree(false);
			setShowArtDegree(true);
			setShowLess(false);
			setShowDoctorDegree(false)
		} else if (degree === "divinity") {
			setShowArtDegree(false);
			setShowDivinityDegree(true);
			setShowDoctorDegree(false);
			setShowLess(false);
		} else {
			setShowArtDegree(false);
			setShowDivinityDegree(false);
			setShowDoctorDegree(true);
			setShowLess(false);
		}
	}

	const handleDataBack = () => {
		setShowDivinityDegree(false);
		setShowArtDegree(false);
		setShowDoctorDegree(false);
		setShowLess(true)
	}

  const handleRequestInfo = () => {
		setOpenRequestInfoModal(true);
	}

	const closeModals = () => {
		setOpenRequestInfoModal(false);
		}

	return (
		<>
			<div className="degree-page degree-page-new">
				{openRequestInfoModal &&
					<RequestInfoModal
						programProps={props.programs}
						sourcesProps={props.sources}
						closeModals={closeModals}
					/>
				}
				{
				showLess &&
					<>
					<div className="container-new" ref={el => elementRef.current["islamic-chaplaincy"] = el}>
						<h1 className="text-center headingF headingF-sm">CHOOSE A DEGREE</h1>

						<div className="choose-degree-block choose-degree-block-two">
							<div className={`inner-block active`} onClick={() => toggleDegree("arts")}>
								<img src={`${process.env.IMAGES_BASE_URL}/static-content/master-in-arts-degree.png.webp`} alt="MASTER OF ARTS (MA) RELIGIOUS STUDIES" />
								<p>MASTER OF ARTS (MA)<br /> RELIGIOUS STUDIES</p>
							</div>
							<div className={`inner-block active'}`} onClick={() => toggleDegree("divinity")}>
								<img src={`${process.env.IMAGES_BASE_URL}/static-content/master-in-divinity.png.webp`} alt="MASTER OF DIVINITY (MDIV) ISLAMIC CHAPLAINCY" />
								<p>MASTER OF DIVINITY (MDIV)<br /> ISLAMIC CHAPLAINCY</p>
							</div>
							<div className={`inner-block active'}`} onClick={() => toggleDegree("doctor")}>
								<img src={`${process.env.IMAGES_BASE_URL}/static-content/master-in-divinity.png.webp`} alt="MASTER OF DIVINITY (MDIV) ISLAMIC CHAPLAINCY" />
								<p>DOCTOR OF MINISTRY (DMIN)<br /> ISLAMIC LEADERSHIP</p>
							</div>
						</div>
					</div>
					</>
				}
				{
					showArtDegree &&
						<div className="w3-animate-left main-nini" id="islamic-studies" >
							<div className="left-side-nini">
								<ul>
									<li><b>Concentrations</b></li>
								<li onClick={() => toggleActiveState("studies")} className={sideBarActiveState.studies ? 'active' : ''}><a href="#studies">Islamic Studies</a></li>
								<li onClick={() => toggleActiveState("leadership")} className={sideBarActiveState.leadership ? 'active' : ''}><a href="#leadership">Islamic Leadership</a></li>
								<li onClick={() => toggleActiveState("advanced")} className={sideBarActiveState.advanced ? 'active' : ''}><a href="#advanced"> Islamic Theology</a></li>
								<li onClick={() => toggleActiveState("education")} className={sideBarActiveState.education ? 'active' : ''}><a href="#education">Islamic Education</a></li>
								</ul>
							</div>
							<div className="container-small">
								<div>
									<span className="fullwide">
										<a onClick={() => handleDataBack()} className="backbtn">Back</a>
									</span>
									<h2>MASTER OF ARTS (MA)<br />RELIGIOUS STUDIES</h2>

									<div>
										<h5>MASTER OF ARTS (MA) RELIGIOUS STUDIES</h5>
										<p>This is a 48 unit Master’s degree that can be completed in two academic years on a full-time basis. The program provides men and women with a firm grounding in Islamic Studies, develops interreligious and intra-faith understanding, and cultivates scholarly and professional skills in several concentration areas. The concentrations facilitate varying interests and aspirations of students in the MA program. <br/><br/>
										Students will take a majority of courses offered by Bayan faculty. Some required and elective courses will be taken with CTS faculty. <br/> <br/>
										To complete the program, students enroll in a Master’s Thesis Seminar and prepare a thesis addressing a topic in their chosen concentration.</p>
									</div>
								</div>

								<div>
								<h3>Required: 16 Courses (All Concentrations)</h3>
								<h5>Required Core Courses for All Concentrations (5):</h5>
								<div>
									<Accordian accordions={requiredAccordions} setAccordions={setRequiredAccordions} />
								</div>
								<h5>Additional Required Courses for All Concentrations (2):</h5>
								<p>1 Bayan interreligious or intra-faith course. Select from:</p>
								<div>
									<Accordian accordions={additionalRequiredAccordions} setAccordions={setAdditionalRequiredAccordions} />
								</div>

								<h5>1 CTS interreligious course. <a href="https://www.ctschicago.edu/wp-content/uploads/2020/09/Course-Listing-2019-2022-8.pdf">See CTS Course Catalog.</a> </h5>
								<h5>2 CTS Elective courses. <a href="https://www.ctschicago.edu/wp-content/uploads/2020/09/Course-Listing-2019-2022-8.pdf">See CTS Course Catalog.</a> </h5>
								<h5>MA Thesis Seminar</h5>
								<div>
									<br/>
									<br/>
									<h5>Concentrations</h5>
									<Studies showRequestInfo={handleRequestInfo} islamicData={props?.islamicData}/>
									<Leadership showRequestInfo={handleRequestInfo} islamicLeadershipData={props?.islamicLeadershipData}/>
									<Advanced showRequestInfo={handleRequestInfo} islamicTheologiesData={props?.islamicTheologiesData}/>
									<Education showRequestInfo={handleRequestInfo} islamicEducationData={props?.islamicEducationData}/>
								</div>
							</div>
							</div>
						</div>
				}
				{
					showDivinityDegree &&
					<div className="container-small">
						<div className="choose-degree-block w3-animate-right" id="islamic-chaplaincy" ref={el => elementRef.current["islamic-chaplaincy"] = el}>

								<span className="fullwide margin-top-10">
									<a onClick={() => handleDataBack()} className="backbtn">Back</a>
								</span>
								<Chaplaincy showRequestInfo={handleRequestInfo} islamicChaplainciesData={props?.islamicChaplainciesData}/>

						</div>
					</div>
				}
				{
					showDoctorDegree &&
					<div className="container-small">
						<div className="choose-degree-block w3-animate-right" id="islamic-chaplaincy" ref={el => elementRef.current["islamic-chaplaincy"] = el}>

								<span className="fullwide margin-top-10">
									<a onClick={() => handleDataBack()} className="backbtn">Back</a>
								</span>
								<DoctorOfMinistry showRequestInfo={handleRequestInfo} islamicDoctorData={props?.islamicDoctorData}/>

						</div>
					</div>
				}
			</div>
		</>
	);
}

export default Degree;
